export function searchFix() {
    $(".search-panel").on("mousewheel", function(e) {
        e.stopPropagation();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/algolia-scroll-fix.js